import {
  IonAlert,
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonLoading,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar
} from '@ionic/react'
import { addCircle, home } from 'ionicons/icons'
import React, { useState } from 'react'
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import EigenheimSteps from "../../components/eigenheim.steps"
import AdditionalBuildingCard, { AdditionalBuilding } from '../../components/form/additional.building.card'
import Note from "../../components/note"
import { State } from '../../store'
import { addNotification, addNotificationType } from '../../store/notification'
import { setAdditional, setAdditionalType, setBuilding, setBuildingType } from "../../store/quote"

interface StateProps {
  decoded: any
  building: any
  additional: any;
}

interface DispatchProps {
  addNotification: addNotificationType
  setBuilding: setBuildingType
  setAdditional: setAdditionalType;
}

type Props = StateProps & DispatchProps & RouteComponentProps<{}>

const Building: React.FC<Props> = (props) => {
  React.useEffect(() => {
    if (!props.decoded) {
      props.history.push({ pathname: '/home' })
    }
  }, [props.decoded])

  const decoded = props.decoded || {
    address: {},
    building: {},
    additional: {},
  }

  if (!decoded.addtional) {
    decoded.addtional = {}
  }

  if (!decoded.addtional.buildings) {
    decoded.addtional.buildings = []
  }

  const [exitConfirm, setExitConfirm] = useState(false)
  const [showLoading, setShowLoading] = useState(false);
  const [toast, setToast] = useState<string>('');

  const [hasBuildings, setHasBuildings] = useState((props.additional.buildings || []).length > 0 || decoded.addtional.buildings.length > 0)

  const [groundFloor, setGroundFloor] = useState(props.building.groundFloor || decoded.building.area_ground_floor || '');
  const [firstFloor, setFirstFloor] = useState(props.building.firstFloor || decoded.building.area_first_floor || '');
  const [secondFloor, setSecondFloor] = useState(props.building.secondFloor || decoded.building.area_second_floor || '');
  const [mansarde, setMansarde] = useState(props.building.mansarade || decoded.building.area_mansarde || '');
  const [basement, setBasement] = useState(props.building.basement || decoded.building.area_basement || '');

  const [buildings, setBuildings] = useState<AdditionalBuilding[]>(props.additional.buildings || decoded.addtional.buildings)

  React.useEffect(() => {
    if (!hasBuildings || buildings.length > 0) {
      return
    }

    setBuildings([{
      id: Date.now(),
      name: '',
      area: 0,
    }])
  }, [hasBuildings])

  const confirm = async () => {
    if (!(!hasBuildings || (buildings.length > 0 && buildings.reduce<boolean>((valid, building) => {
      return valid && !!building.name && !!building.area
    }, true)))) {
      props.addNotification({
        color: 'warning',
        message: 'Nebegebäude Daten fehlen!',
      })
      return
    }

    setShowLoading(true);

    await props.setBuilding({
      groundFloor,
      firstFloor,
      secondFloor,
      mansarde,
      basement,
    })

    await props.setAdditional({
      ...props.additional,
      buildings: hasBuildings ? buildings : [],
    })

    setShowLoading(false)
    props.history.push({ pathname: '/additional' })
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/home' })}>
              <IonIcon slot="icon-only" icon={home} />
            </IonButton>
          </IonButtons>
          <IonTitle>Eigenheim Versicherung</IonTitle>
          <IonButtons slot="primary">
            {/*
            <IonButton color="dark" onClick={() => setExitConfirm(true)}>
              <IonIcon slot="icon-only" icon={refresh} color={'primary'} />
            </IonButton>
            */}
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Verarbeite...'}
        />
        <IonToast
          isOpen={Boolean(toast)}
          color={'warning'}
          onDidDismiss={() => setToast('')}
          message={toast}
          duration={1500}
        />

        <EigenheimSteps current={2}/>

        <Note>
          Bitte bestätige die Daten zu deinem Eigenheim
        </Note>

        <IonItemGroup style={{marginTop: 16, marginLeft: -16, marginRight: -16}}>
          <IonItemDivider>
            <IonLabel>Gebäude Daten</IonLabel>
          </IonItemDivider>

          <IonItem>
            <IonLabel position="floating">Erdgesschoss m<sup>2</sup></IonLabel>
            <IonInput value={groundFloor} type={'number'} min={'1'} max={'10'} onIonChange={e => setGroundFloor((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">1. Obergeschoss m<sup>2</sup></IonLabel>
            <IonInput value={firstFloor} type={'number'} min={'1'} max={'10'} onIonChange={e => setFirstFloor((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">2. Obergeschoss m<sup>2</sup></IonLabel>
            <IonInput value={secondFloor} type={'number'} min={'1'} max={'10'} onIonChange={e => setSecondFloor((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">Mansarde m<sup>2</sup></IonLabel>
            <IonInput value={mansarde} type={'number'} min={'1'} max={'10'} onIonChange={e => setMansarde((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel position="floating">Keller m<sup>2</sup></IonLabel>
            <IonInput value={basement} type={'number'} min={'1'} max={'10'} onIonChange={e => setBasement((e.target as HTMLInputElement).value)} />
          </IonItem>

          <IonItem>
            <IonLabel>Versicherte Nebengebäude?</IonLabel>
            <IonCheckbox slot="end" checked={hasBuildings} onClick={() => setHasBuildings(!hasBuildings)} />
          </IonItem>
        </IonItemGroup>

        <IonItemGroup style={{marginTop: '32px', marginLeft: -16, marginRight: -16, display: hasBuildings ? null : 'none'}}>
          <IonItemDivider>
            <IonLabel>Nebengebäude</IonLabel>
            <IonButton slot="end" onClick={() => setBuildings([...buildings, {
              id: Date.now(),
              name: '',
              area: 0
            }])}>
              <IonIcon icon={addCircle}/> &nbsp; weitere Nebengebäude
            </IonButton>
          </IonItemDivider>

          {buildings.map((building) => (
            <AdditionalBuildingCard
              building={building}
              onDelete={() => setBuildings(buildings.filter((o) => o.id !== building.id))}
              onChange={p => setBuildings(buildings.map((o) => o.id === building.id ? p : o))}
              key={building.id}
            />
          ))}
        </IonItemGroup>

        <IonAlert
          isOpen={exitConfirm}
          onDidDismiss={() => setExitConfirm(false)}
          header={'Neu starten?'}
          message={'Alle eingegeben Daten werden verworfen und der Prozess beginnt von vorn!'}
          /*buttons={[
            'Abbrechen',
            {
              text: 'Neu Starten!',
              handler: () => {
                props.history.push({ pathname: '/home' })
              }
            }
          ]}*/
        />
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/address' })}>
              Zurück
            </IonButton>
          </IonButtons>
          <IonButton color="primary" expand={'block'} onClick={() => confirm()}>weiter</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default connect<StateProps, DispatchProps, unknown, State>(
  ({scan, quote}) => {
    return {
      decoded: scan.decoded,
      building: quote.building,
      additional: quote.additional,
    }
  },
  {
    setBuilding,
    setAdditional,
    addNotification,
  }
)(Building);
